<template>
  <div style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;flex-direction: column;" @touchmove.prevent>
    <div style="display: flex;justify-content: center;align-items: center;width: 100vw;height: 100vh;flex-direction: column;background-color: #16151586;">

      <div style="display: flex;justify-content: start;align-items: center;flex-direction: column;background-size: 100% 100%;"
      :style="{ 'background-image': 'url(' + backgroundBg + ')','width':'60vw','height':'calc(60vw / 1.970695)'}">

        <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;height: 21.3%;flex-direction: row;">
          <span style="width: 10px;height: 100%;"></span>
          <span style="width: 8vw;height: 100%;background-color: transparent;" @click="cancelReservationPage()"></span>
        </div>
        <div style="display: flex;justify-content: start;align-items: center;width: calc(60vw * 0.8);height: calc(60vw / 1.970695 * 0.168);flex-direction: column;">
          <input class="fontStyle" type="number" v-model="phoneValue" placeholder="请输入手机号" style="border: none;width: 100%;height: 100%;background-color: transparent;color:black;font-weight: bold;font-size: 2vw;" >
        </div>
        <div style="display: flex;justify-content: start;align-items: center;width: 60%;height: 7.2%;flex-direction: column;"></div>

        <div style="display: flex;justify-content: space-between;align-items: center;width: calc(60vw * 0.8);height: calc(60vw / 1.970695 * 0.168);flex-direction: row;background-color: transparent;">
          <div style="display: flex;justify-content: start;align-items: center;width: 48%;height: 100%;flex-direction: column;">
            <input class="fontStyle" type="number" v-model="verifyCode" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="请输入验证码" style="border: none;width: 100%;height: 100%;background-color: transparent;color:black;font-weight: bold;font-size: 2vw;">
          </div>
          <div style="display: flex;justify-content: center;align-items: center;width: calc(60vw * 0.8 * 0.265);height: 100%;flex-direction: column;background-color: transparent;color: black;font-weight: bold;font-size: 2vw;" @click="getCode()">
            {{ show?'获取验证码':'发送中('+count+')' }}
          </div>
        </div>
        <div style="width: 100%;height: 8%;"></div>
        <div style="width: 80%;height: 15%;" @click="goReservation()"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import { request } from '../network/request';
  import { mapMutations } from "vuex" 
  export default {
    props:{
      
    },
    data () {
      return {
        backgroundBg: require('@/assets/pictures/login-bg.png'),
        phoneValue: '',
        verifyCode: '',
        show: true ,
        count: '',
        timer: null
      }
    },
    components: {

    },
    methods: {
      ...mapMutations(['switchToast']),
      getCode(){
        if (!this.show) {
          return
        }
        if (this.phoneValue.length <= 0) {
          this.switchToast({"showOrHide": true, "toastMessage": "请输入手机号"});
          return true;
        }
        const TIME_COUNT = 60;
        this.count = TIME_COUNT;
        let paramters = {'phone':this.phoneValue, 'type':'appointment'}
        paramters = qs.stringify(paramters)
        request({
          url:this.urls.sendAppointmentSms,
          data: paramters,
        }).then(res =>{
          this.show = false;
          // 开始倒计时
          if (!this.timer) {
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                this.count = '';
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        });
      },
      goReservation(){
        if (this.phoneValue.length <= 0) {
          this.switchToast({"showOrHide": true, "toastMessage": "请输入手机号"});
          return true;
        }
        if (this.verifyCode.length <= 0) {
          this.switchToast({"showOrHide": true, "toastMessage": "请输入验证码"});
          return true;
        }

        // this.switchToast({"showOrHide": true, "toastMessage": "预约成功！"});

        let paramters = {'phone':this.phoneValue, 'code':this.verifyCode, 'pageid':'5', 'cp_id':'10060'}
        paramters = qs.stringify(paramters)
        request({
          url:this.urls.appointment,
          data: paramters,
        }).then(res =>{
          this.switchToast({"showOrHide": true, "toastMessage": "预约成功！"});
          this.$emit('goReservation', true)
        });

      },
      cancelReservationPage(){
        this.$emit('goReservation', false)
      }
    }
 }
</script>

<style>

input::placeholder{
  color: black
}
 
</style>


// WEBPACK FOOTER //
// src/views/PhoneReservation.vue